<template>
    <div>
        <v-container>
            <v-row no-gutters>
                <v-col :cols="6">
                    <h1 class="headline font-weight-light mb-3">
                        <router-link class="link-a" to="/Inventory/Same-Item"
                            >SAME ITEM</router-link
                        >
                        / CREATED
                    </h1>
                </v-col>
                <v-col :cols="6" class="text-right">
                    <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        small
                        rounded
                        @click="add_case()"
                    >
                        <v-icon small class="mr-1">mdi-plus</v-icon>
                        Add Case
                    </v-btn>
                </v-col>
            </v-row>

            <v-card class="mt-5 pa-5">
                <v-row class="text-right">
                    <v-col cols="12">
                        <v-btn small rounded color="success"
                            ><v-icon small class="mr-1"
                                >mdi-content-save</v-icon
                            >
                            Save</v-btn
                        >
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-center">Project</th>
                                        <th class="text-center">Supplier</th>
                                        <th class="text-center">CSO</th>
                                        <th class="text-center">
                                            Serial Number
                                        </th>
                                        <th class="text-center">Part No</th>
                                        <th class="text-center">
                                            Part Description
                                        </th>
                                        <th class="text-center">Symptoms</th>
                                        <th>#</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
        <ProjectAll @add_case="add_case()" :dialog="dialog" />
    </div>
</template>
<script>
import ProjectAll from "./components/ProjectAll"
export default {
    components: {
        ProjectAll: ProjectAll
    },
    methods: {
        add_case() {
            this.dialog = this.dialog === false ? true : false
        }
    },
    data() {
        return {
            dialog: false
        }
    }
}
</script>
